/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/RemoveAllSubStrings.ts
 * @create:      2025-07-01 18:00:16.498
 * @modify:      2025-07-11 21:19:12.829
 * @version:     6.0.0
 * @times:       5
 * @lines:       67
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ReplaceAll } from "./ReplaceAll";

/**
 * Removes all occurrences of the specified substrings from the input string.
 *
 * @param str - The original string from which substrings will be removed.
 * @param subStrings - One or more substrings to remove from the original string.
 * @returns The resulting string after all specified substrings have been removed.
 *
 * @remarks
 * If no substrings are provided, the original string is returned unchanged.
 * If a substring is an empty string, it is ignored.
 *
 * @example
 * ```typescript
 * RemoveAllSubStrings("hello world", "l", "o"); // returns "he wrd"
 * ```
 * 
 * @since 4.0.0
 * @version 2021-12-09
 */
export function RemoveAllSubStrings(str: string, ...subStrings: string[]) {
    if (str.length > 0) {
        if (subStrings.length > 0) {
            for (const s of subStrings) {
                if (s.length > 0) {
                    str = ReplaceAll(str, s, "");
                }
            }
        }
    }

    return str;
}
